import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import app from 'new-ui/app';
import { hcpApi } from 'modules/hcp/api';
import { ShareWithDoctorPopup } from './ShareWithDoctorPopup';

const prepareRequestPayload = ({ formData: { doctorFirstName, doctorLastName, doctorEmail }, patientUserWixId }) => ({
  doctorFirstName,
  doctorLastName,
  doctorEmail,
  patientUserWixId,
});

export const HCPShareWithDoctor = ({ closePopup, patientUserWixId }) => {
  const { t } = useTranslation();
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = (formData) => {
    app.showPreloader();
    hcpApi.sharePatientMatchesWithDoctor(prepareRequestPayload({ formData, patientUserWixId }))
      .then(() => {
        setIsSent(true);
        setTimeout(() => {
          closePopup();
        }, 1000);
      })
      .finally(() => {
        app.hidePreloader();
      });
  };

  return (
    <ShareWithDoctorPopup
      title={t('hcp_share_with_doctor.title')}
      onSubmit={handleSubmit}
      isSent={isSent}
    />
  );
};

HCPShareWithDoctor.propTypes = {
  closePopup: PropTypes.func.isRequired,
  patientUserWixId: PropTypes.string.isRequired,
};
